export function getLogoutLink(): string {
  return "/signout";
}
